
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchAdminThunk } from "slices/userSlice";
import { MdSkipNext, MdSkipPrevious } from "react-icons/md";
import Card from "components/card";
import { deleteSubAdminThunk } from "slices/userSlice";
import PopUpAlertModal from "components/modals/popUpAlertModal";
import { notify } from "common/toastUtil";
import { clearUniqueCode } from "slices/userSlice";
import { columnsDataColumns } from "../tables/variables/columnsData";
import ColumnsTable from "../tables/components/ColumnsTable";

const AgentPage = () => {
      const dispatch = useDispatch();
  const admin=useSelector((state) => state?.users);
const [adminId,setAdminId]=useState("");
const [openAlert,setOpenAlert]=useState(false)

const [pageB, setPageB] = useState(1); // Agent table
const {uniqueCode,data}=useSelector((state)=>state?.users)
const itemsPerPage = 5;
const appAdmin = admin?.data?.data?.length >0 ? admin?.data?.data?.filter((user) => user.role === "appAdmin") : [];
const agent =admin?.data?.data?.length>0 ? admin?.data?.data?.filter((user) => user.role === "agent") : [];


const pagedAgents = agent.slice(
  (pageB - 1) * itemsPerPage,
  pageB * itemsPerPage
);
const totalPagesB = Math.ceil(agent.length / itemsPerPage);
  useEffect(()=>{
dispatch(fetchAdminThunk())
  },[dispatch])
  const deleteSubAdmin=(id)=>{
    setAdminId(id)
    if(id){
      setOpenAlert(true)
    }
    
  }
useEffect(() => {
  if (data?.status === 201 ) {
    notify("success", data?.message);
    dispatch(fetchAdminThunk());
  }
    if (data?.status === 200 && uniqueCode ) {
    notify("success", data?.message);
    dispatch(fetchAdminThunk());
  }

  if (data?.status !== 200 && data?.status !== 201 && uniqueCode) {
    notify("error", data?.message);
  }

  dispatch(clearUniqueCode());
}, [data?.status, data?.message, uniqueCode, dispatch]); 
  return (
   <div>
              <PopUpAlertModal openAlert={openAlert} setOpenAlert={setOpenAlert} title="Are you sure you want to delete this Sub Admin?" clickHandler={()=>dispatch(deleteSubAdminThunk(adminId))} />
      <div className="flex justify-content-around w-full mt-4">
<Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold"> Total Admin Count:{admin?.users?.data?.data?.length || 0}</Card>
<Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold"> App Admin Count:{appAdmin?.length || 0}</Card>
<Card className="w-1/3 bg-white rounded-md p-4 m-2 font-bold"> Agent Count:{agent?.length || 0}</Card>

</div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
    

        {pagedAgents?.length > 0 && <div>
          <ColumnsTable
            title="Agent Table"
            columnsData={columnsDataColumns}
            tableData={pagedAgents?.length > 0 ? pagedAgents : []}
                deleteSubAdmin={deleteSubAdmin}
          />
          {/* Pagination controls */}
          {totalPagesB > 1 && (
            <div className="flex gap-2 justify-center my-2">
              <button onClick={() => setPageB(p => Math.max(1, p - 1))} disabled={pageB === 1}>
                <MdSkipPrevious />
              </button>
              {Array.from({ length: totalPagesB }, (_, i) => (
                <button key={i + 1} onClick={() => setPageB(i + 1)} className={i + 1 === pageB ? 'font-bold' : ''}>
                  {i + 1}
                </button>
              ))}
              <button onClick={() => setPageB(p => Math.min(totalPagesB, p + 1))} disabled={pageB === totalPagesB}>
                <MdSkipNext />
              </button>
            </div>
          )}
        </div>}
      </div>
    </div>
  )
}

export default AgentPage
